export default function accordion() {
    return {
        openItem: null,

        toggle(index) {
            this.openItem = this.openItem === index ? null : index;
        },

        isOpen(index) {
            return this.openItem === index;
        },

        chevronClass(index) {
            return this.openItem === index ? 'rotate-180' : '';
        },

        init() {},

        destroy() {},
    };
}
